function Lupa() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            // width={30}
            height={25}
            viewBox="0 0 171 171"
            style={{
                fill: "#000",
            }}
        >
            <g
                fill="none"
                strokeMiterlimit={10}
                fontFamily="none"
                fontWeight="none"
                fontSize="none"
                textAnchor="none"
                style={{
                    mixBlendMode: "normal",
                }}
            >
                <path d="M0 171.991V0h171.991v171.991z" />
                <path
                    d="M85.5 6.84C42.098 6.84 6.84 42.098 6.84 85.5c0 43.402 35.258 78.66 78.66 78.66 43.402 0 78.66-35.258 78.66-78.66 0-43.402-35.258-78.66-78.66-78.66zm0 6.84c39.706 0 71.82 32.114 71.82 71.82 0 39.706-32.114 71.82-71.82 71.82-39.706 0-71.82-32.114-71.82-71.82 0-39.706 32.114-71.82 71.82-71.82zm-3.42 30.78v37.62H44.46v6.84h37.62v37.62h6.84V88.92h37.62v-6.84H88.92V44.46z"
                    fill="#fff"
                />
            </g>
        </svg>
    )

}

export default Lupa;